// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DPU-container-terrain {
  margin-top: 3px;
  border-top: 1px solid var(--border-color-1);
  width: 100%;
  margin-bottom: 5px;
  padding: 5px 10px;
}
.DPU-container-checkbox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DPU-container-terrain .checkbox-container {
  display: flex;
  align-items: center;
}
.container-range-transparent-globe{
  margin-top: 5px;

}
.DPU-container-terrain .DPU-container-checkbox .disable,.DPU-container-terrain .container-range-transparent-globe .disable {
  opacity: 0.5;
  cursor: no-drop;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mapWeather/mapTerrain.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;;AAEjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".DPU-container-terrain {\r\n  margin-top: 3px;\r\n  border-top: 1px solid var(--border-color-1);\r\n  width: 100%;\r\n  margin-bottom: 5px;\r\n  padding: 5px 10px;\r\n}\r\n.DPU-container-checkbox {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.DPU-container-terrain .checkbox-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.container-range-transparent-globe{\r\n  margin-top: 5px;\r\n\r\n}\r\n.DPU-container-terrain .DPU-container-checkbox .disable,.DPU-container-terrain .container-range-transparent-globe .disable {\r\n  opacity: 0.5;\r\n  cursor: no-drop;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
